import basicRequest from "../../../../core/redux/actions/request";

const PREFIX = "MANAGER_JOB_FILES";
const getState = (state) => state.manager.job.files;

const {
    postPattern,
    actionPostPattern,
    actionPutPattern,
    actionDeletePattern,
    secondaryPostPattern,
    secondaryPutPattern,
    secondaryDeletePattern,

    error,
    loading,
    success,
    reset,

    secondaryError,
    secondaryLoading,
    isSecondaryLoading,
    secondarySuccess,
    secondaryReset: formReset,

    isLoaded,
    isLoading,
    getError,
    getData,

    getSecondarySuccess: getFormSuccess,
    getSecondaryError: getFormError,

    generalPostDownload,
} = basicRequest(PREFIX, getState);

export { reset, isLoading, isLoaded, getError, getData, getFormSuccess, getFormError, formReset, isSecondaryLoading };

export const executeAction = (id, form) => postPattern(`manager/jobs/v1/${id}/file-manager/action`, form, null);
export const executeDownload = (id, location, meta) =>
    generalPostDownload(`manager/jobs/v1/${id}/file-manager/secondary`, meta?.name, {
        action: "DOWNLOAD_FILE",
        location: location,
        name: meta?.name,
        fullname: meta?.fullname,
    });

export const executeDownloadFolder = (id, location, meta) =>
    generalPostDownload(`manager/jobs/v1/${id}/file-manager/secondary`, `${meta?.name}.zip`, {
        action: "DOWNLOAD_FOLDER",
        location: location,
        name: meta?.name,
        fullname: meta?.fullname,
    });
